import { render } from "./Logistics.vue?vue&type=template&id=024c2f8c&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=024c2f8c&lang=css"
import "./Logistics.vue?vue&type=style&index=1&id=024c2f8c&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024c2f8c"]])

export default __exports__